import { render } from "./ManagePage.vue?vue&type=template&id=56e17287&scoped=true&ts=true"
import script from "./ManagePage.vue?vue&type=script&lang=ts"
export * from "./ManagePage.vue?vue&type=script&lang=ts"

import "./ManagePage.vue?vue&type=style&index=0&id=56e17287&scoped=true&lang=css"

import exportComponent from "C:\\Users\\manya\\Documents\\Development\\Production\\Vue\\bbf-africa-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56e17287"]])

export default __exports__